import type { ServiceConsultant, ServiceConsultantProgram } from 'types';

export const getServiceConsultantName = (consultant: ServiceConsultant): string =>
    [consultant.firstname, consultant.middlename, consultant.lastname].filter(Boolean).join(' ');

export const getLocalizedServiceName = (
    service: ServiceConsultantProgram,
    language = 'EN'
): string => {
    switch (language.toUpperCase().split('-')[0]) {
        case 'FR':
            return service.name_fr || service.name_en;
        case 'ES':
            return service.name_es || service.name_en;
        default:
            return service.name_en;
    }
};
